// 后台菜单
let backMenu = [
  {
    path: "/back/movement",
    name: "movement",
    component: resolve =>
      require(["@/components/back/movement/index"], resolve),
    meta: {
      title: "新闻中心"
    }
  },
  {
    path: "/back/recruit",
    name: "recruit",
    component: resolve => require(["@/components/back/recruit/index"], resolve),
    meta: {
      title: "招贤纳士"
    }
  },
  {
    path: "/back/imgSet",
    name: "imgSet",
    component: resolve => require(["@/components/back/imgSet/index"], resolve),
    meta: {
      title: "栏目背景"
    }
  },
  {
    path: "/back/modifyPwd",
    name: "modifyPwd",
    component: resolve =>
      require(["@/components/back/modifyPwd/index"], resolve),
    meta: {
      title: "修改密码",
      noMenu: true
    }
  }
];
export default backMenu;



// WEBPACK FOOTER //
// ./src/router/back.js